import { context, trace } from '@opentelemetry/api';
import { logger } from '@parrot-software/observability';

import type { IPaymentMethodApiPort } from '@subscriptions/application/ports';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const paymentLog = logger.forDomain('SUB', { subdomain: 'billing' });
const tracer = trace.getTracer('@parrot-software/observability');

/**
 * Use case for forcing collection of a block's pending payment ("Reintentar pago").
 *
 * @param port - Payment method API port
 * @returns Use case executor
 */
export const forcePaymentUseCase = (port: IPaymentMethodApiPort) => {
  const execute = async (blockUuid: string): Promise<void> => {
    const span = tracer.startSpan('SUB.forceBlockPayment', {
      attributes: { 'block.uuid': blockUuid },
    });
    const ctx = trace.setSpan(context.active(), span);

    return context.with(ctx, async () => {
      try {
        await port.forcePayment(blockUuid);
        paymentLog.info('forceBlockPayment', { 'block.uuid': blockUuid });
      } catch (error) {
        paymentLog.error('forceBlockPayment', { 'block.uuid': blockUuid, ...extractErrorAttributes(error) });
        throw error;
      } finally {
        span.end();
      }
    });
  };

  return { execute };
};
